import * as S from './style';
const MembershipFee = () => (
	<>
		<S.Container>
			<S.Title>회비안내</S.Title>
			<S.Table>
				<S.TableHeadCell>회원구분</S.TableHeadCell>
				<S.TableHeadCell>회비</S.TableHeadCell>

				<S.PositionCell className="min-height">정회원</S.PositionCell>
				<S.TableCell>80,000원</S.TableCell>

				<S.PositionCell className="min-height">학생회원</S.PositionCell>
				<S.TableCell>20,000원</S.TableCell>
			</S.Table>
		</S.Container>
		<S.Container>
			<S.Title>회비납부방법</S.Title>
			<S.DescriptionBox>
				<S.SubTitle>은행계좌</S.SubTitle>
				<S.Description>하나은행 748-910007-79804 (예금주: 한국노화학회)</S.Description>
			</S.DescriptionBox>
			<S.DescriptionBox>
				<S.SubTitle>신용카드</S.SubTitle>
				<S.Description>학회 홈페이지 회원정보 로그인 후 결제 가능</S.Description>
			</S.DescriptionBox>
		</S.Container>
		<S.Container>
			<S.Title>회원 가입 방법</S.Title>
			<S.Description>한국노화학회 홈페이지에서 온라인 가입</S.Description>
		</S.Container>
	</>
);
export default MembershipFee;
